function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Multi_home_box"
}, /*#__PURE__*/React.createElement("title", null, "VF_alarm_rgb"), /*#__PURE__*/React.createElement("path", {
  d: "M49.6 56.7H85V85H49.6zM113.4 56.7h35.4V85h-35.4zM49.6 106.3H85v28.3H49.6zM113.4 106.3h35.4v28.3h-35.4zM49.6 155.9H85v28.3H49.6zM113.4 155.9h35.4v28.3h-35.4zM49.6 205.5H85v28.3H49.6zM113.4 205.5h35.4v28.3h-35.4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M283.5 127.6h-85V7.1H0v276.4h283.5V127.6zM170.1 255.1H28.3V35.4H170v219.7zm85 0h-56.7v-14.2h42.5v-14.2h-42.5v-14.2h42.5v-14.2h-42.5v-14.2h42.5V170h-42.5v-14.1h56.7v99.2z"
}))));